import { createBrowserRouter } from "react-router-dom";
import { Layout } from "../components/Layout";
import { DashboardPage } from "../pages/DashboardPage";
import { HealthPage } from "../pages/HealthPage";
import { ShopifyConnectionPage } from "../pages/ShopifyConnectionPage";
import { DatabaseStatusPage } from "../pages/DatabaseStatusPage";
import { MigrationJobsPage } from "../pages/MigrationJobsPage";
import { MatchesPage } from "../pages/MatchesPage";
import { ShopifySchemaPage } from "../pages/ShopifySchemaPage";
import { SandlotExplorerPage } from "../pages/SandlotExplorerPage";
import { CustomerInspectorPage } from "../pages/CustomerInspectorPage";
import { MatchReviewPage } from "../pages/MatchReviewPage";
import { MigrationPreviewPage } from "../pages/MigrationPreviewPage";
import { MigrationTestingPage } from "../pages/MigrationTestingPage";
import { ClubMigrationPage } from "../pages/ClubMigrationPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "health", element: <HealthPage /> },
      { path: "shopify", element: <ShopifyConnectionPage /> },
      { path: "shopify-schema", element: <ShopifySchemaPage /> },
      { path: "database", element: <DatabaseStatusPage /> },
      { path: "sandlot", element: <SandlotExplorerPage /> },
      { path: "inspector", element: <CustomerInspectorPage /> },
      { path: "match-review", element: <MatchReviewPage /> },
      { path: "preview", element: <MigrationPreviewPage /> },
      { path: "testing", element: <MigrationTestingPage /> },
      { path: "club-migration", element: <ClubMigrationPage /> },
      { path: "jobs", element: <MigrationJobsPage /> },
      { path: "matches", element: <MatchesPage /> },
    ],
  },
]);
